import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export const LineIcon = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path
      d="M14,40H8V34h6ZM34,14h6V8H34ZM13.5,34.5l21-21"
      style={{ fill: '#fff', stroke: '#000', strokeMiterlimit: 10, strokeWidth: 3.5 }}
    />
  </SvgIcon>
);

export const RectangleIcon = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path
      d="M14,14H8V8h6ZM40,8H34v6h6ZM14,34H8v6h6Zm26,0H34v6h6ZM14,11H34M14,37H34M11,14V34M37,14V34"
      style={{ fill: '#fff', stroke: '#000', strokeMiterlimit: 10, strokeWidth: 3.5 }}
    />
  </SvgIcon>
);

export const PolygonIcon = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path
      d="M14,14H8V8h6ZM40,8H34v6h6ZM14,34H8v6h6Zm26,0H34v6h6ZM27,21H21v6h6ZM14,37H34M14,11H34M11,14V34M26.5,21.5l8-8m-8,13,8,8"
      style={{ fill: '#fff', stroke: '#000', strokeMiterlimit: 10, strokeWidth: 3.5 }}
    />
  </SvgIcon>
);

export const CircleIcon = props => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <path
      d="M21,40.5v-6h6v3.17l.63-.17a14,14,0,0,0,9.87-9.87l.17-.63H35V21h6v6H37.76l-.09.39A13.51,13.51,0,0,1,27.39,37.68l-.39.08V40.5Zm-1-3a13.55,13.55,0,0,1-9.68-10.14L10.23,27H7.5V21h6v6H10.32l.17.63A14,14,0,0,0,20,37.4ZM37.4,20a14,14,0,0,0-9.4-9.4v-.13A13.55,13.55,0,0,1,37.53,20ZM10.46,20A13.55,13.55,0,0,1,20,10.46v.13a14,14,0,0,0-9.4,9.4ZM21,13V7h6v6Z"
      style={{ fill: '#fff', stroke: '#000', strokeMiterlimit: 10, strokeWidth: 3.5 }}
    />
  </SvgIcon>
);
